<template>
  <div class="user-main">
      <p>最近更新日期：2021年11月23日。</p>
      <p>本版本生效日期：2021年11月23日。</p>
      <p>欢迎使用灵云产品及服务（以下简称“本软件”）！</p>
      <p>北京捷通华声科技股份有限公司（以下简称“捷通华声”或“我们”）作为灵云产品及服务的所有者及运营者，非常重视用户（以下简称“用户”或“您”）数据的隐私与安全，当您在使用灵云产品及服务时，捷通华声可能会收集和使用您的相关信息。捷通华声承诺，我们将按照法律法规的规定，采取相应的安全措施来保护您的个人信息及隐私安全。本政策向您说明我们会如何以收集、保存、使用及对外使用等方式来处理您的个人信息。</p>
      <p>请您在使用灵云产品及服务之前或在您注册账户使用我们服务时，您应当认真阅读并了解本《隐私政策》。您在注册页面勾选“我同意隐私政策”，当您填写注册信息并点击“创建用户”时，您的前述行为即表示您已同意授权我们按照本政策来合法收集、使用您的个人信息。出于业务、技术的发展以及更好提供服务的目的，我们会适时对本《隐私政策》进行更新。本隐私政策更新后，并以合适方式公示或告知，请您及时了解并查阅相关内容。如您不同意本协议或更新后的任何条款，请您立即停止使用捷通华声提供的灵云产品和服务。</p>
      <p>当我们要将您的个人信息用于本政策未载明的其它用途时，或将基于特定目的收集而来的个人信息用于其他目的时，我们会事先以显著方式、清晰易懂的语言将相关事项单独告知您并征求您的同意，只有在获取您的同意之后才会按照您的授权和告知事项使用您的个人信息。</p>
      <p>本《隐私政策》将帮助您了解：</p>
      <p>一、定义与解释</p>
      <p>二、个人信息的收集和使用</p>
      <p>三、Cookies及相关技术</p>
      <p>四、个人信息的保护</p>
      <p>五、个人信息的共享、转让和披露</p>
      <p>六、个人信息的管理</p>
      <p>七、个人信息的存储</p>
      <p>八、第三方服务</p>
      <p>九、未成年人信息保护</p>
      <p>十、本政策的更新和通知</p>
      <p>十一、联系我们</p>
      <p>十二、争议解决</p>
      <div class="user-h3 important">一、定义与解释</div>
      <p>1.1 灵云产品与/或服务</p>
      <p>灵云产品与/或服务，是指捷通华声通过灵云输入法App（以下简称“本软件”）向用户提供的产品与/或服务，包括利用拼音、智能语音、手写、笔画、拍照输入多种输入方式及使用其他功能进行快捷高效输入服务（一下简称“本服务”）。</p>
      <p>1.2 北京捷通华声科技有限公司</p>
      <p>北京捷通华声科技有限公司是灵云系列产品的经营者，专业从事智能语音及语言技术研究、软件及语音信息服务及电子政务系统集成。注册地址/常用办公地址：北京市海淀区东北旺北京中关村软件园，联系电话：010-82585188。</p>
      <p>1.3 用户</p>
      <p>用户是指注册、登录以及使用本软件及本服务的用户，在本政策中更多地称为“您”。 </p>
      <p>1.4 个人信息</p>
      <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息，包括但不限于自然人的姓名、出生日期、身份证件号码、个人生物识别信息、住址、电话号码。为免疑义，个人信息包括但不限于个人敏感信息。</p>
      <p>1.5 个人敏感信息</p>
      <p>个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息。个人敏感信息包括但不限于身份证件号码、个人生物识别信息、银行账号、通信内容、健康生理信息。</p>
      <p>1.6 个人信息主体</p>
      <p>个人信息主体指个人信息所标识的自然人。</p>
      <p>1.7 去标识化</p>
      <p>去标识化指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。</p>
      <p>1.8 匿名化</p>
      <p>匿名化指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。</p>
      <p>1.9 设备</p>
      <p>设备是指可用于访问灵云输入法服务的装置，例如台式计算机、笔记本电脑、平板电脑或智能手机。</p>
      <p>1.10 唯一设备标识符</p>
      <p>唯一设备标识符（专属 ID 或 UUID）是指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备（移动设备的 IMEI 号）。唯一设备标识符有多种用途，包括可在不能使用cookies时用以提供广告。</p>
      <p>1.11 IP地址</p>
      <p>每台上网的设备都会指定一个编号，称为互联网协议 (IP) 地址。这些编号通常都是根据地理区域指定的。IP 地址通常可用于识别设备连接至互联网时所在的位置。</p>
      <p>1.12 GPS</p>
      <p>Global Positioning System（全球定位系统）的简称。您使用的设备上的GPS信号接收器可以从GPS卫星收到信号并利用传来的信息计算您的位置。</p>
      <p>1.13 WIFI</p>
      <p>Wi-Fi是一种允许电子设备连接到一个无线局域网（WLAN）的技术，通常我们所说的无线网络。</p>
      <p>1.14 基站</p>
      <p>基站，即公用移动通信基站，是无线电台站的一种形式，是指在一定的无线电覆盖区中，通过移动通信交换中心，与移动电话终端之间进行信息传递的无线电收发信电台。</p>
      <p>1.15 SSL</p>
      <p>SSL（Secure Socket Layer）又称为安全套接层，是在传输通信协议（TCP/IP）上实现的一种安全协议。SSL支持各种类型的网络，同时提供三种基本的安全服务，均通过使用公开密钥和对称密钥技术以达到信息保密的效果。</p>
      <p>1.16 信息收集技术</p>
      <p>在本政策中所述的“自动收集”包括以下方式：</p>
      <p>（1）Cookie</p>
      <p>Cookie是您浏览网页时，网站服务器放在客户端（您的计算机、移动电话或其他智能终端内）里面的一个小小的文本文件，可用于改善您的使用体验。</p>
      <p>（2）Web beacon（网络信标）</p>
      <p>Web beacon是装嵌在网站或电邮内的电子图像文件案或其他技术，可用于计算访客数目、记录您是否及何时阅览电邮或网站，或用以使用某些Cookie。</p>
      <p>（3）Log files（日志文件）</p>
      <p>Log files储存自动收集的若干数据。该等数据包括互联网协议（IP）地址、浏览器类型、互联网服务提供商（ISP）、引用/退出页面、操作系统、日期/时间戳和点击流数据等。</p>
      <p>（4）ET Tag（实体标签）</p>
      <p>ET Tag是在互联网浏览器与互联网服务器之间背后传送的HTTP协议标头，可代替Cookie，用以追踪个别使用者，使我们可更深入地了解和改善我们的服务。</p>
      <p>（5）JavaScript</p>
      <p>JavaScript是一种编程语言，用于制作更具互动性和动态的网页。JavaScript可以设定Cookie、阅读Cookie及删除Cookie。</p>
      <div class="user-h3 important">二、个人信息的收集和使用</div>
      <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息。为了向您提供优质的服务，我们根据合法、正当、必要的原则，会出于以下目的，收集和使用您的个人信息：</p>
      <p>2.1 注册、登录和注销</p>
      <p>当您注册灵云账号时需要填写及或提交的信息，包括您的<span style="font-weight: bold;">手机号、登录密码、电子邮箱</span>等信息。我们将通过向您的手机号码发送短信验证码来验证您的身份是有效，在验证完成后您还需要完善相关的网绛身份识别信息（您需要设置登录密码）。我们同时提供使用您的第三方账户（如微信、 QQ）的方式来注册账号，如您选择授权使用三方账号（如微信、QQ）注册，您将同时授权我们从该第三方获取您主动共享的账号信息（<span style="font-weight: bold;">头像、昵称、地区、性别</span>）与您的账号进行绑定，并用于快捷注册成为我们的注册用户以及后续的账号登录，我们会依据与该第三方的约定及您的授权，在符合相关法律法规的前提下，使用您的授权第三方账号信息。收集这些信息是为了帮您创建账号，如果您拒绝提供这些信息，您将无法注册成为注册用户以及享有注册用户的专有权益，但不会影响您使用灵云产品的其他功能。</p>
      <p>如果您不再使用灵云产品和服务，您有权注销您的灵云听语账户，您可以在APP中我的-设置-账号注销中，使用多种方式申请账号注销。我们收到您的请求核验成功后将在15个工作日内为您完成注销。为了保障安全，我们可能需要您提供相应方式证明您的身份和请求的正当性。您注销成功后，我们将根据法律法规的要求尽快删除您的个人信息或作匿名化处理。</p>
      <p>2.2 产品功能的正常使用和改进</p>
      <p>在使用捷通华声灵云产品和服务时，出于保证产品正常使用和持续改善的目的，我们可能会收集您使用的日志和设备信息。</p>
      <p>（1）日志信息</p>
      <p>您知晓并同意，您在使用灵云产品和服务时，系统可能通过cookies或其他方式自动收集某些信息并存储在服务器日志中。此类信息可能包括：对灵云产品和服务的使用情况，<span style="font-weight: bold;">设备或软件信息，设备事件信息（包括崩溃、系统活动信息及其他相关信息）</span>等。我们不会将日志信息用于本政策所述目的之外的任何用途。</p>
      <p>（2）设备信息</p>

      <span>您知晓并同意，为了进行必要的适配及提供安全服务，捷通华声会收集您使用灵云产品或服务的设备的</span><span style="font-weight: bold;">硬件型号、操作系统版本号、唯一设备标识符、IP地址、蓝牙、WIFI等网络标识及状态</span><span>等相关信息。收集这些信息是为了帮助我们进行bug分析，保障您正常使用灵云产品和服务、改进和优化我们的产品体验、保障您的账号安全。除本政策另有明确约定外，捷通华声不会将您的设备信息提供给任何第三方。</span>

      <p>（3）个人敏感信息</p>
      <p>个人敏感信息是一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。我们不会收集、使用您的任何个人敏感信息</p>
      <p>2.3 为您提供产品功能及服务</p>
      <p>（1）音频录制</p>
      <p>在灵云产品部分功能下，您可能需要录制个人音频或上传音频文件以用于后续的语音识别和翻译。在您正式启用录制之前，我们会向您申请<span style="font-weight: bold;">麦克风的权限</span>，您在同意和授权后可以在应用内录制音频。在您使用音频转写和翻译的服务时，我们将收集您的<span style="font-weight: bold;">语音信息</span>进行语音转写于翻译。同时，我们会收集转写后的<span style="font-weight: bold;">文本信息</span>，给您提供文本分析、分享等服务。</p>
      <p>（2）图片拍摄</p>
      <p>在灵云产品部分功能下，您可能需要拍摄图像以用于后续的图像识别。在您正式启用拍摄之前，我们会向您申请<span style="font-weight: bold;">摄像头的权限</span>，您在同意和授权后可以在应用内拍摄图片。我们将收集您的<span style="font-weight: bold;">图片信息</span>进行分析，以提供二维码识别等功能。</p>
      <p>（3）连接智能硬件</p>
      <p>为了向您提供连接智能硬件的功能，我们将通过手机智能硬件<span style="font-weight: bold;">设备SN号、Mac地址</span>，进行本软件与录音笔的配对连接。此类信息属于连接智能硬件功能服务的必要信息。在完成配对连接后，我们仅会在您主动开启本软件内的录音和文件传输功能时，才会通过蓝牙进行数据传输，包括传输其他设备上的信息，并在云端存储。在您连接智能硬件时，我们需要调用您的<span style="font-weight: bold;">蓝牙权限和访问地址权限</span>，如您拒绝开启前述权限，您将无法连接智能硬件。</p>
      <p>（4）订单购买</p>
      <p>当您在我们的产品中订购某些商品或服务时，我们会通过系统为您生成购买该商品或服务的订单并收集相关的<span style="font-weight: bold;">订单信息（用户ID、订单号、订单来源、订单价格、实际支付价格、支付渠道、支付方式、发票信息、会员类型、充值卡类型等）</span>。在部分服务项目中，您可能需要提供<span style="font-weight: bold;">收货人个人身份信息，如联系人、收货地址、邮政编码、联系电话、支付状态等信息。</span></p>
      <p>（5）问题反馈</p>
      <p>当您联系我们的客服或使用反馈功能时（包括售后申请、个人建议、问题反馈），我们可能需要您提供必要的<span style="font-weight: bold;">个人信息</span>以匹配并核验您的用户身份，以便保障您的账号与系统安全。我们可能还会保存您的<span style="font-weight: bold;">联系方式</span>、您与我们的<span style="font-weight: bold;">通信/通话记录和内容</span>、与您需求相关联的其他必要信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>
      <p>（6）剪切板</p>
      <p>当前在灵云听语中选择主动复制、粘贴相关文字进行内容输入时，会触发系统的<span style="font-weight: bold;">剪切板权限</span>。再次过程中，我们不会读取和上传您的剪切板信息到我们的服务器。</p>
      <p>2.4 其他可能收集的信息</p>
      <p>（1）其他用户发布的信息中可能包含您的信息。</p>
      <p>（2）您在使用第三方合作伙伴服务时所产生或分享的信息，当您使用微信、QQ账号及其他第三方账号登录我们的软件产品或服务时，我们需要核实您的身份或绑定您的账户信息，经过您的授权将相关账号关联到我们的产品或服务中。我们将在符合相关法律法规规定，并依据与第三方合作伙伴的约定、确信其提供的个人信息来源合法的前提下，收集并使用您的这些个人信息。</p>
      <p>2.5 依法豁免征得同意收集和使用的个人信息</p>
      <p>根据法律法规及相关国家标准，我们在以下情形收集和使用您的个人信息无需征得您的授权同意：</p>
      <p>（1）与国家安全、国防安全有关的；</p>
      <p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>
      <p>（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
      <p>（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
      <p>（5）所收集的个人信息是您自行向社会公众公开的；</p>
      <p>（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
      <p>（7）根据您的要求签订合同所必需的；</p>
      <p>（8）为公共利益实施合法的新闻报道所必需的，但会在合理范围内处理个人信息；</p>
      <p>（9）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
      <p>（10）法律法规规定的其他情形。</p>
      <p>2.6 您理解并同意，捷通华声可能需要您在您的设备中开启特定的访问权限，以实现产品功能的正常使用，但均会基于您同意的情况下获取权限：</p>
      <p>（1）访问位置信息，是为了根据您的位置信息为您提供更符合您需求的页面展示和产品服务，如您禁止访问您的位置信息，将仍旧为您提供服务，但是可能无法为您提供更符合需求的页面展示及服务；</p>
      <p>（2）访问摄像头，是为了使您可以使用摄像头进行扫码、拍摄，用于实现登录、支付、拍照识别、拍照翻译功能，如您禁止访问您的摄像头将无法使用该功能；</p>
      <p>（3）访问相册，是为了使您可以上传您设备中的照片或视频，便于您进行更换头像、图片识别如您禁止访问您的相册将无法使用该功能；</p>
      <p>（4）访问麦克风，是为了使您可以实现实时录音识别、语音翻译，如您禁止访问您的麦克风将无法使用该功能；</p>
      <p>（5）获取OAID和AndroidID，用于向用户推送音频转写结果通知，方便用户及时获取转写内容； </p>
      <p>（6）获取WIFI等网络SSID标识，用于判断用户网络类型，方便用户选择是否使用当前网络下载资源文件；</p>
      <p>请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的个人信息收集及使用。</p>
      <p>2.7 信息推送</p>
      <p>我们收集您的订单信息、设备信息等，用于消息推送。</p>
      <div class="user-h3 important">三、Cookies及相关技术</div>
      <p>3.1 您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookies的小数据文件。Cookies文件是存储了一些与用户访问网站有关信息的文件。Cookies内容通常均经过加密，安全的Cookie技术会为用户在上网时提供更为便捷的服务。我们使用该信息判断注册用户是否已经登录、记录用户偏好、提升服务/产品质量及优化用户体验。</p>
      <p>3.2 如您不希望个人信息保存在 Cookies中，您可对浏览器进行设置，选择禁用Cookies功能。禁用Cookies功能后，则您可能无法使用依赖于Cookie部分的捷通华声提供的灵云产品和服务，并因此无法获得最佳的服务体验，但不会影响您使用我们的其他服务。</p>
      <div class="user-h3 important">四、个人信息的保护</div>
      <p>4.1 捷通华声采用符合业界标准的安全防护措施，来防止用户个人信息在意外的、未经授权的情况下被非法访问、复制、修改、传送、遗失、破坏、处理或使用。在某些服务中，捷通华声将利用加密技术、匿名化处理等手段来保护您提供的个人信息，并通过隔离技术进行隔离。</p>
      <p>4.2 捷通华声设立严格的数据使用和访问制度，采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。</p>
      <p>4.3 网络环境中始终存在各种信息泄漏的风险，当出现意外事件、不可抗力等情形导致您的信息出现泄漏时，捷通华声将尽最大努力降低影响范围和风险。</p>
      <p>4.4 尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但互联网并非绝对安全的环境，捷通华声强烈建议您，不要通过不安全途径进行交流或发送个人信息，积极采取措施保证个人信息的安全，如：使用较复杂密码，定期修改账号密码，不将自己的账号密码等个人信息透露给他人。</p>
      <div class="user-h3 important">五、个人信息的共享、转让和披露</div>
      <p>5.1 共享</p>
      <p>未经您的单独同意和授权，捷通华声不会以任何方式与本公司及本公司的关联公司以外的任何公司、组织和个人共享您的个人信息，以下情况除外：</p>
      <p>（1）事先获得您明确的单独同意或授权；</p>
      <p>（2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；</p>
      <p>（3）应您需求在事先获得您明确的同意或授权的情况下，为您处理您与他人的纠纷或争议；</p>
      <p>（4）符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</p>
      <p>（5）基于学术研究而使用；</p>
      <p>（6）基于符合法律法规的社会公共利益而使用，并在合理的范围内处理您的个人信息。</p>
      <p>5.2 转让</p>
      <p>特殊情况下，我们有可能进行合并、收购、资产转让、破产清算或类似的交易，而您的个人信息有可能作为此类交易的一部分而被转移，我们会向您告知个人信息接收方的名称或者姓名和联系方式。我们会要求新的持有您个人信息的公司、组织继续受本《隐私政策》的约束，如个人信息接收方变更原先的处理目的、处理方式的，我们将要求该公司、组织重新向您征求授权同意。</p>
      <p>5.3 披露</p>
      <p>我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，披露您的个人信息：</p>
      <p>（1）获得您明确同意后；</p>
      <p>（2）根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式披露您的个人信息；</p>
      <p>（3）在应对突发公共卫生事件或紧急情况下，为了保护您、捷通华声及其他用户的生命健康和财产安全或公共安全及利益的。</p>
      <div class="user-h3 important">六、个人信息的管理</div>
      <p>6.1 您有权访问、修改、删除、撤回您的个人信息；但相关信息的删除或修改可能会影响您对相关产品或服务的使用或导致部分功能的实现。</p>
      <p>6.2 在使用捷通华声灵云产品和服务中，我们会明确公示所需要申请的必需权限，也会明确告知本隐私协议的全部内容，除非得到您的授权，否则这些权限将不会被开启。同时，您还可以在设备操作系统当中关闭这些权限。请您知晓，必要权限会影响产品的主要功能使用，如果您拒绝对必要权限进行授权或在设备操作系统中关闭必要授权，都将影响您对产品的使用。</p>
      <p>6.3 您可以通过联系我们申请注销相关产品账户。您注销账户后，捷通华声将停止为您提供与账号相关的产品或服务功能，并将删除处理您的个人信息，除法律法规另有规定或您另有要求外。</p>
      <div class="user-h3 important">七、个人信息的存储</div>
      <p>7.1 我们依照国家法律法规的规定，将境内收集的用户个人信息存储在中华人民共和国境内。我们会采取合适的安全措施和技术手段存储及保护您的个人信息，以防止丢失、被误用、受到未授权访问或泄漏、被篡改或毁坏。您的个人信息存放在有密码控制的位于中国境内的服务器中，我们会采取严格的保护措施保证您的个人信息安全，遵守中国法律法规，且所有访问请求均是受到限制的，只有符合我们严格的数据访问权限，才会允许必要的访问，且我们会严格遵守中国法律规定对待来自境外的访问请求。</p>
      <p>7.2 您在使用捷通华声提供的灵云产品和服务期间，我们将对您的个人信息进行存储。存储期限严格按照法律及相关法规规定，最低期限不少于6个月。超出存储期限的情况下，您的个人信息将可能被删除处理，法律法规另有规定的除外。</p>
      <p>7.3 当我们的产品或服务发生停止运营的情形时，我们将采取包括但不限于推送通知、公告等形式通知您，在停止运营后对您的个人信息进行删除或匿名化处理，法律法规或监管部门另有规定的除外。</p>
      <div class="user-h3 important">八、第三方服务</div>
      <p>8.1 为了给您提供更好的客户服务和用户体验，捷通华声灵云产品和服务可能链接至第三方提供的服务（包括网站或其他服务形式）。包括：</p>
      <p>（1）您可利用“分享”功能将某些内容分享到第三方平台，或您可利用第三方服务登录灵云产品和服务；</p>
      <p>（2）我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站；</p>
      <p>（3）其他接入第三方服务的情形。为实现本政策中声明的目的，我们可能会接入第三方服务商提供的SDK或其他类似的应用程序，并将我们依照本政策收集的您的某些信息共享给该等第三方服务商，我们会提前在征得您同意的情况下，提供服务，并向您告知个人信息接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类。对我们与之共享个人信息的第三方公司或组织，我们会与其签署严格的保密协定，要求他们按照我们的说明、政策及其他任何相关的保密和安全措施来处理您的信息。</p>
      <p>（4）以下是接入第三方SDK信息</p>
      <div class="sdk-list">
        <CustomTable
          :option="option"
          :tableData="tableData"
        >
        </CustomTable>
      </div>
      <p>8.2 当您使用第三方服务（包括您向第三方提供的任何个人信息），须受第三方的服务条款及个人信息保护声明（而非本政策）约束，您需要仔细阅读第三方的相关条款。</p>
      <div class="user-h3 important">九、未成年人信息保护</div>
      <p>9.1 捷通华声非常重视未成年人的个人信息保护，若您为18周岁以下的未成年人，请您及您的监护人仔细阅读本政策，并在征得您的监护人同意的前提下使用我们的产品或服务或向我们提供信息。</p>
      <p>9.2 捷通华声根据国家相关法律法规的规定保护未成年人的个人信息，对于经监护人同意而收集未成年人个人信息的情况，我们只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下使用或披露此信息。如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，我们则会设法尽快删除相关数据。</p>
      <p>9.3 若您是18周岁以下的未成年人，在通过我们的信息系统及技术服务向第三方直接提供信息前，您亦应事先取得您法定监护人的同意，如您或您的监护人拒绝向第三方提供相关信息的，或不同意第三方向您或您的监护人告知的信息收集使用规则的，则您不得使用第三方服务功能，我们作为技术服务方可在法律法规允许的范围内协助您联系信息收集方处理相关事宜，但无法对第三方合作方直接向您收集、使用个人信息的行为承担责任。</p>
      <p>9.4 作为监护人，您可以联系我们，我们将协助您对进行未成年人相关信息进行查看、修改及删除。如果有事实证明未成年人并未取得监护人同意的情况下注册和使用了我们的服务，监护人可以联系我们的客服，我们会在确认后尽快删除相关未成年人的个人信息。</p>
      <p>9.5 对于不满14周岁的儿童个人信息，我们还会遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，按照《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露。当您作为监护人为被监护的儿童选择使用我们的服务时，我们可能需要根据本政策向您收集被监护的儿童个人信息，用于向您履行相关服务之必要。如果您不提供前述信息，将会影响您使用我们的相关服务。您作为监护人应当正确履行监护职责，保护儿童个人信息安全，如您对我们收集、使用儿童个人信息相关事宜有任何意见、建议或投诉，请联系我们。</p>
      <div class="user-h3 important">十、更新和通知</div>
      <p>10.1 本隐私政策可能随时被更新，新修订的隐私政策发布之后将完全代替之前版本的隐私政策。您应定期查看以了解我们最新的隐私政策条款。隐私政策变更后，我们会以包括但不限于弹窗、短信等形式向您告知隐私政策的更新。您有权选择接受或拒绝更新的隐私政策。如您拒绝接受更新后的隐私政策，将会影响您使用我们的软件及服务中涉及包括但不限于文字识别、翻译、跨屏输入、语音转写的部分；如果您接受更新后的隐私政策，请根据通知页面的提示内容，明确选择您同意接受修改后的隐私政策。</p>
      <p>10.2 更新后的隐私政策将在灵云产品网站及客户端上公布，重大变更将以网站公告、用户通知、弹窗提示等合适的形式告知用户。当您使用我们的产品和服务时，您可以随时审查我们的隐私政策，以便您了解其修改。</p>
      <div class="user-h3 important">十一、联系我们 </div>
      <p>如您对本隐私政策或您的个人信息事宜有任何疑问、建议、投诉，请通知捷通华声。您可以通过如下方式联系捷通华声：</p>
      <p>地址：北京市海淀区东北旺北京中关村软件园孵化器2号楼一层2101室 </p>
      <p>电话：010-82826886</p>
      <p>邮箱：aicloud_support@sinovoice.com.cn</p>
      <p>邮编：100193</p>
      <div class="user-h3 important">十二、争议解决 </div>
      <p style="margin-bottom: 100px">当您因为本政策的实施与我们产生任何纠纷时，双方应首先协商友好解决；若不能协商解决，可以提交我们所在地人民法院诉讼解决。</p>
      <div class="company" style="margin-bottom: 100px">北京捷通华声科技股份有限公司</div>
    </div>
</template>

<script>
import CustomTable from '../components/CustomTable'
export default {
  name: 'UserPersonal',
  components: {
    CustomTable
  },
  data () {
    return {
      option: {
        column: [
          { label: 'SDK名称', prop: 'name' },
          { label: '所属公司', prop: 'company' },
          { label: 'SDK类型', prop: 'type' },
          { label: 'SDK接入目的', prop: 'purpose' },
          { label: '个人信息字段', prop: 'field' },
          { label: '隐私协议连接', prop: 'link' }
        ]
      },
      tableData: [
        {
          name: 'com.igexin.sdk<br/>com.igexin.push',
          company: '每日互动股份有限公司',
          type: '推送服务',
          purpose: '推送转写结果通知',
          field: '设备识别码（详见“隐私政策”）、设备平台、设备厂商用于生成唯一的推送目标ID（CID）和设备ID（GID）、应用列表信息、网络信息以及位置相关信息',
          link: '个推-隐私政策 (getui.com)'
        },
        {
          name: 'com.alipay支付宝',
          company: '支付宝',
          type: '支付服务合作',
          purpose: '提供支付服务',
          field: '网络类型、设备型号、设备制造商、SIM 卡序列号、IMEI、MAC地址、ANDROID_ID、IP 地址、WiFi 信息、应用安装列表、OpenUDID、BSSID地址',
          link: '支付宝隐私权政策 (alipay.com)'
        },
        {
          name: 'com.umeng友盟',
          company: '北京锐讯灵通科技有限公司',
          type: '监控应用性能',
          purpose: '统计分析',
          field: '1.本机设备信息 （IMEI/Android ID）2.读写存储 3.网络连接信息 4.应用列表 5.位置信息 6.MAC地址',
          link: '【友盟+】隐私政策 (umeng.com)'
        },
        {
          name: 'com.tencent.bugly腾讯bugly',
          company: '深圳市腾讯计算机系统有限公司',
          type: '应用异常上报',
          purpose: '提供应用异常信息上报、统计分析服务',
          field: '网络类型、设备型号、设备制造商、SIM 卡序列号、IMEI、MAC地址、ANDROID_ID、IP 地址、WiFi 信息、应用安装列表、OpenUDID、BSSID地址',
          link: '腾讯隐私保护平台 (qq.com)'
        },
        {
          name: '腾讯开放SDK',
          company: '深圳市腾讯计算机系统有限公司',
          type: '支付服务合作',
          purpose: '提供支付服务',
          field: '网络类型、设备型号、设备制造商、SIM 卡序列号、IMEI、MAC地址、ANDROID_ID、IP 地址、WiFi 信息、应用安装列表、OpenUDID、BSSID地址',
          link: '腾讯隐私保护平台 (qq.com)'
        },
        {
          name: 'com.google.android谷歌SDK',
          company: '谷歌',
          type: '基于Android开发、基础UI框架、基础应用层服务框架（如Camera功能支持）',
          purpose: '基于Android开发、基础UI框架、基础应用层服务框架（如Camera功能支持）',
          field: '无',
          link: 'https://policies.google.com/'
        }
      ]
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.user-main{
  text-align: left;
  padding: 32px;
}
.important {
  color: #333;
  font-size: 28px;
  font-weight: bold;
  line-height: 72px;
  margin-bottom: 30px;
}
p {
  line-height: 40px;
  font-size: 26px;
  color: #666;
  font-family: PingFang SC;
  font-weight: 500;
  margin-bottom: 15px;
}
span {
  line-height: 40px;
  font-size: 26px;
  color: #666;
  font-family: PingFang SC;
  font-weight: 500;
  margin-bottom: 15px;
}
.company {
  font-size: 26px;
  color: #666;
  font-family: PingFang SC;
  font-weight: 500;
  text-align: right;
}
.sdk-list{
  margin: 20px 0;
}
</style>
